<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  async created () {
    // 在应用启动时获取菜单与全局配置，供 layout / 首页共用
    await Promise.all([
      this.$store.dispatch('fetchMenuList'),
      this.$store.dispatch('fetchGlobalConfig')
    ])
  }
}
</script>

<style>
/* 全局CSS重置 */
* {
  box-sizing: border-box;
}
.banner-section {
  width: 100%;
  min-height: 550px;
  height: auto !important;
}

@media (max-width: 768px) {
  .banner-section {
    min-height: unset;
  }
}
.el-drawer__header {
  margin-bottom: 0;
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e6e6e6;
}
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

body {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#app {
  width: 100%;
  min-height: 100vh;
}

/* 全局滚动条美化 - WebKit 浏览器 (Chrome, Safari, Edge) */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #c0c0c0;
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: #a0a0a0;
}

/* Firefox 滚动条 */
* {
  scrollbar-width: thin;
  scrollbar-color: #c0c0c0 #f5f5f5;
}
.ql-align-center {
  text-align: center;
}
</style>
